import React from 'react';
import { motion } from 'framer-motion';

const customEase = [0.16, 1, 0.3, 1];

export default function InfiniteMarquee() {
  const items = [
    "COMMERCIAL STUDIOS",
    "PODCAST SUITES",
    "RECORDING ROOMS",
    "PRODUCTION BAYS"
  ];

  // Repeat items to ensure the block is significantly wider than any screen resolution
  // This guarantees the seamless loop works on ultra-wide monitors
  const blockItems = [...items, ...items, ...items, ...items, ...items];

  return (
    <motion.section 
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.4, ease: customEase }}
      className="w-full bg-[#0D0D0D] py-24 sm:py-32 will-change-[transform,opacity]"
    >
      {/* 1. INTRO TYPOGRAPHY BLOCK */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center mb-16 sm:mb-24">
        <h2 className="text-[#FFFFFF] text-3xl sm:text-4xl font-semibold tracking-tight mb-5 sm:mb-6">
          Built for the room you run.
        </h2>
        <p className="text-[#D4D4D8] text-lg sm:text-[19px] font-normal max-w-2xl mx-auto leading-[1.6]">
          From single-set spaces to commercial multi-studio networks, StudioTimer handles the pacing so you can handle the production.
        </p>
      </div>

      {/* 2 & 3. INFINITE MARQUEE BAR STRUCTURE & TEXT STYLING */}
      <div className="w-full bg-[#1A1A1A] py-8 sm:py-12 overflow-hidden relative flex items-center border-y border-[#27272A]">
        {/* Subtle film grain scoped perfectly over the strip itself */}
        <div className="film-grain"></div>
        
        {/* The w-max container holds two identical block segments. 
            Translating it by -50% creates a flawless infinite loop. */}
        <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
          {[...Array(2)].map((_, i) => (
            <div key={i} className="flex items-center" aria-hidden={i === 1}>
              {blockItems.map((item, index) => (
                <React.Fragment key={`${i}-${index}`}>
                  <span className="text-[#D4D4D8] text-sm sm:text-base font-mono uppercase tracking-[0.2em] px-6 sm:px-10">
                    {item}
                  </span>
                  <span className="text-[#555] opacity-60 text-lg">
                    •
                  </span>
                </React.Fragment>
              ))}
            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}